import React, { useState, useEffect } from 'react';
import TextBox from 'devextreme-react/ui/text-box';
import Button from 'devextreme-react/ui/button';
import './keyword-search.scss';

const __DEFAULT_SEARCH_QUERY = 'preferred-route-load-number';

const KeywordSearch = ({ keyword, onSearch, placeholder }) => {
  const [searchQuery, setSearchQuery] = useState(keyword || '');

  useEffect(() => {
    if (!searchQuery && sessionStorage.getItem(__DEFAULT_SEARCH_QUERY)) {
      const stored = sessionStorage.getItem(__DEFAULT_SEARCH_QUERY) || '';
      setSearchQuery(stored);
      onSearch(stored);
    }
  }, []);

  useEffect(() => {
    setSearchQuery(keyword || '');
  }, [keyword]);

  if (keyword == null && placeholder == null) {
    return null;
  }

  const buttonClickHandler = () => {
    sessionStorage.setItem(__DEFAULT_SEARCH_QUERY, searchQuery || '');
    onSearch(searchQuery || '');
  };

  const enterKeyHandler = () => {
    sessionStorage.setItem(__DEFAULT_SEARCH_QUERY, searchQuery || '');
    onSearch(searchQuery || '');
  };

  return (
      <div className="keyword-search-container">
        <table className="keyword-search-table">
          <tbody>
          <tr>
            <td className="keyword-search-button-container">
              <Button
                  type="default"
                  width={36}
                  height={36}
                  icon="icon ion-android-search"
                  text=""
                  onClick={buttonClickHandler}
              />
            </td>
            <td className="keyword-search-textbox-container">
              <TextBox
                  value={searchQuery}
                  placeholder={placeholder || undefined}
                  onValueChanged={(e) => setSearchQuery(e.value)}
                  onEnterKey={enterKeyHandler}
                  showClearButton={true}
              />
            </td>
          </tr>
          </tbody>
        </table>
      </div>
  );
};

export default KeywordSearch;
